<template>
  <b-row>
    <b-col md="6">
      <b-card>
        <template #header>
          <div class="d-flex justify-content-between">
            <h4>Interior Checks</h4>
            <b-checkbox v-model="value.interiorCheck" switch :value="1" :unchecked-value="0" />
          </div>
        </template>
        <b-card-body>
          <b-row>
            <b-col sm="12" md="6">
              <div class="d-flex align-items-center label-list">
                <i class="fa fa-info-circle text-primary mr-3" v-b-tooltip.hover title="Green Cards are found in the glove compartment, they are to be updated on a monthly basis. Members does not need to carry out further damage reporting for damage that are already indicated in the green card." />
                <span>Green Card Date</span>
              </div>
              <div class="d-flex align-items-center label-list">
                <i class="fa fa-info-circle text-primary mr-3" v-b-tooltip.hover title="Check for sound when horn is depressed. Engine might need to be started to sound the horn. " />
                <span>Horn</span>
              </div>
              <div class="d-flex align-items-center label-list">
                <i class="fa fa-info-circle text-primary mr-3" v-b-tooltip.hover title="Insert a cashcard/EZ-Link card/NETS Flashpay card to test. The balance amount should be displayed when the card is inserted." />
                <span>IU</span>
              </div>
              <div class="d-flex align-items-center label-list">
                <i class="fa fa-info-circle text-primary mr-3" v-b-tooltip.hover title="Carpet of the vehicle should be dusted on every visit, the carpet should be clipped onto the carpet holder for selected vehicle make and model." />
                <span>Dusting of Carpet</span>
              </div>
              <div class="d-flex align-items-center label-list">
                <i class="fa fa-info-circle text-primary mr-3" v-b-tooltip.hover title="After usage, member will leave used tissue paper, rubbish, receipts and other items in the car. It is the PIC’s responsibility to clear all items which are not supposed to be in there for the convenience for the next member’s usage." />
                <span>Cleaning of Interior Rubbish</span>
              </div>
            </b-col>
            <b-col>
              <b-form-group v-model="value.interiorCheckRemarks" label="Remarks">
                <b-textarea />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>

    <b-col md="6">
      <b-card>
        <template #header>
          <div class="d-flex justify-content-between">
            <h4>Engine Bay</h4>
            <b-checkbox v-model="value.engineBay" switch :value="1" :unchecked-value="0" />
          </div>
        </template>
        <b-card-body>
          <b-row>
            <b-col sm="12" md="6">
              <div class="d-flex align-items-center label-list">
                <i class="fa fa-info-circle text-primary mr-3" v-b-tooltip.hover title="Check the engine oil before starting the engine and on level ground, remove the dipstick and wipe it clean. Push the dipstick all the way in and then withdraw it and check the level. The oil should be between the two marks. Remember to push the dipstick fully in when refitting." />
                <span>Engine Oil Level</span>
              </div>
              <div class="d-flex align-items-center label-list">
                <i class="fa fa-info-circle text-primary mr-3" v-b-tooltip.hover title="On most cars you can see the brake fluid levels through the transparent plastic reservoirs. If not, remove the cap and check the level inside.The level should be maintained between the maximum and minimum marks. The need for constant topping up indicates the possibility of a leak or the brake pads are worn." />
                <span>Brake Fluid</span>
              </div>
              <div class="d-flex align-items-center label-list">
                <i class="fa fa-info-circle text-primary mr-3" v-b-tooltip.hover title="Check the vehicle’s car is fitted with an expansion  tank that the coolant level is at or slightly above the 'minimum' mark when the engine is cold, or somewhere between the half and 'maximum'marks with the engine at operating temperature. Persistent coolant loss indicates a problem, which your mechanic should check immediately. Do not open the radiator tank cap when the engine is hot. A vehicle without any coolant should not be driven anymore under any circumstances." />
                <span>Coolant</span>
              </div>
              <div class="d-flex align-items-center label-list">
                <i class="fa fa-info-circle text-primary mr-3" v-b-tooltip.hover title="Check for streaking and effectiveness of the wiper. Windscreen washer tank should be topped up to full whenever needed" />
                <span>Windscreen</span>
              </div>
            </b-col>
            <b-col>
              <b-form-group v-model="value.engineBayRemarks" label="Remarks">
                <b-textarea />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>

    <b-col md="6">
      <b-card>
        <template #header>
          <div class="d-flex justify-content-between">
            <h4>Lightning & Electronics</h4>
            <b-checkbox v-model="value.lightingElectronic" switch :value="1" :unchecked-value="0" />
          </div>
        </template>
        <b-card-body>
          <b-row>
            <b-col sm="12" md="6">
              <ul class="label-list" style="list-style-type: none; padding: 0">
                <li>Headlight</li>
                <li>Tail light</li>
                <li>Brake Lights</li>
                <li>Hazard Lights</li>
                <li>Signal Lights</li>
                <li>Cabin Lights</li>
              </ul>
            </b-col>
            <b-col>
              <b-form-group v-model="value.lightingElectronicRemarks" label="Remarks">
                <b-textarea />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>

    <b-col md="6">
      <b-card>
        <template #header>
          <div class="d-flex justify-content-between">
            <h4>Other Checks</h4>
            <b-checkbox v-model="value.otherCheck" switch :value="1" :unchecked-value="0" />
          </div>
        </template>
        <b-card-body>
          <b-row>
            <b-col>
              <div class="d-flex align-items-center label-list">
                <i class="fa fa-info-circle text-primary mr-3" v-b-tooltip.hover title="PIC to start the engine, idle and drive the vehicle around the MSCP to hear for any abnormal noise." />
                <span>Abnormal Sound</span>
              </div>
              <div class="d-flex align-items-center label-list">
                <i class="fa fa-info-circle text-primary mr-3" v-b-tooltip.hover title="All stickers and decals should be pasted to identify Car Club’s fleet of vehicle." />
                <span>Stickers, Decals on the vehicle body and VRN on keytag</span>
              </div>
              <div class="d-flex align-items-center label-list">
                <i class="fa fa-info-circle text-primary mr-3" v-b-tooltip.hover title="Tyres are to be maintained between 210 to 235 PSI. PIC are advised not to over pump the tyres." />
                <span>Inspecting and inflating of all 4 tyres inclusive of spares</span>
              </div>
              <div class="d-flex align-items-center label-list">
                <i class="fa fa-info-circle text-primary mr-3" v-b-tooltip.hover title="PIC are to look out for dents and scratches. They are also to take the relevant photos for damage investigation." />
                <span>Bodyworks</span>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'ChecklistForm',
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style>

</style>